import { createBrowserRouter, Navigate } from 'react-router-dom';
import { ENABLE_GIFT_CARDS } from '../constants/featureFlags';
import Layout from '../components/Layout';
import HomePage from '../pages/HomePage';
import BrowseStylesPage from '../pages/BrowseStylesPage';
import CreateComboPage from '../pages/CreateComboPage';
import CreateStylesPage from '../pages/CreateStylesPage';
import CreateIdentificationPage from '../pages/CreateIdentificationPage';
import CreateConfirmPage from '../pages/CreateConfirmPage';
import CreatePaymentPage from '../pages/CreatePaymentPage';
import CreateSuccessPage from '../pages/CreateSuccessPage';
import RestyleLandingPage from '../pages/RestyleLandingPage';
import RestyleComboPage from '../pages/RestyleComboPage';
import RestyleStylesPage from '../pages/RestyleStylesPage';
import RestyleIdentificationPage from '../pages/RestyleIdentificationPage';
import RestylePaymentPage from '../pages/RestylePaymentPage';
import RestyleSuccessPage from '../pages/RestyleSuccessPage';
import GiftCardLandingPage from '../pages/GiftCardLandingPage';
import GiftCardPersonalisePage from '../pages/GiftCardPersonalisePage';
import GiftCardDeliveryPage from '../pages/GiftCardDeliveryPage';
import GiftCardPaymentPage from '../pages/GiftCardPaymentPage';
import GiftCardSuccessPage from '../pages/GiftCardSuccessPage';
import GiftCardBalancePage from '../pages/GiftCardBalancePage';
import ErrorPage from '../pages/ErrorPage';
import PriceListPage from '../pages/PriceListPage';
import NewsEventsPage from '../pages/NewsEventsPage';
import NewsEventsDetailPage from '../pages/NewsEventsDetailPage';
import BusinessPlatesPage from '../pages/BusinessPlatesPage';
import BrowseStyleDetailPage from '../pages/BrowseStyleDetailPage';
import SearchResultsPage from '../pages/SearchResultsPage';
import AboutPage from '../pages/AboutPage';
import ContactUsPage from '../pages/ContactUsPage';
import HelpPage from '../pages/HelpPage';
import YourPlateYourStoryPage from '../pages/YourPlateYourStoryPage';
import HeritagePlatesAuctionPage from '../pages/HeritagePlatesAuctionPage';
import SevenReserveAuctionPage from '../pages/SevenReserveAuctionPage';
import SignaturePlatesPage from '../pages/SignaturePlatesPage';
import AFLPage from '../pages/AFLPage';
import ChristmasPage from '../pages/ChristmasPage';
import HeritagePlatesSignupPage from '../pages/HeritagePlatesSignupPage';
import SpecialReleaseSignupPage from '../pages/SpecialReleaseSignupPage';
import ExclusiveHeritagePlatesPage from '../pages/ExclusiveHeritagePlatesPage';
import PremiumCollectionPage from '../pages/PremiumCollectionPage';
import TheresAPlateForEveryonePage from '../pages/TheresAPlateForEveryonePage';
import CreateAPlatePage from '../pages/CreateAPlatePage';
import UpdateYourLookPage from '../pages/UpdateYourLookPage';
import SelectPage from '../pages/SelectPage';
import AuctionTermsPage from '../pages/AuctionTermsPage';
import TermsPage from '../pages/TermsPage';
import PrivacyPage from '../pages/PrivacyPage';
import PrivacyCollectionNoticePage from '../pages/PrivacyCollectionNoticePage';
import SitemapPage from '../pages/SitemapPage';
import AccessibilityPage from '../pages/AccessibilityPage';
import NewReleasePage from '../pages/NewReleasePage';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: 'search-results',
        element: <SearchResultsPage />,
      },
      {
        path: 'browse-styles',
        element: <BrowseStylesPage />,
      },
      {
        path: 'browse-styles/euro-premium',
        element: <Navigate to="/browse-styles/euro" replace />,
      },
      {
        path: 'browse-styles/:style',
        element: <BrowseStyleDetailPage />,
      },
      {
        path: 'price-list',
        element: <PriceListPage />,
      },
      {
        path: 'news-and-events',
        element: <NewsEventsPage />,
      },
      {
        path: 'news-and-events/:slug',
        element: <NewsEventsDetailPage />,
      },
      {
        path: 'about',
        element: <AboutPage />,
      },
      {
        path: 'contact-us',
        element: <ContactUsPage />,
      },
      {
        path: 'help',
        element: <HelpPage />,
      },
      {
        path: 'your-plate-your-story',
        element: <YourPlateYourStoryPage />,
      },
      {
        path: 'heritage-plates-auction',
        element: <HeritagePlatesAuctionPage />,
      },
      {
        path: 'signature-plates',
        element: <SignaturePlatesPage />,
      },
      {
        path: 'afl',
        element: <AFLPage />,
      },
      {
        path: 'christmas',
        element: <ChristmasPage />,
      },
      {
        path: 'heritage-plates-email-signup',
        element: <HeritagePlatesSignupPage />,
      },
      {
        path: 'special-release-signup',
        element: <SpecialReleaseSignupPage />,
      },
      {
        path: 'exclusive-heritage-plates',
        element: <ExclusiveHeritagePlatesPage />,
      },
      {
        path: 'seven-reserve-auction',
        element: <SevenReserveAuctionPage />,
      },
      {
        path: 'premium-collection',
        element: <PremiumCollectionPage />,
      },
      {
        path: 'theres-a-plate-for-everyone',
        element: <TheresAPlateForEveryonePage />,
      },
      {
        path: 'create-a-plate',
        element: <CreateAPlatePage />,
      },
      {
        path: 'update-your-look',
        element: <UpdateYourLookPage />,
      },
      {
        path: 'select',
        element: <SelectPage />,
      },
      {
        path: 'auction-terms',
        element: <AuctionTermsPage />,
      },
      {
        path: 'terms',
        element: <TermsPage />,
      },
      {
        path: 'privacy',
        element: <PrivacyPage />,
      },
      {
        path: 'privacy-collection-notice',
        element: <PrivacyCollectionNoticePage />,
      },
      {
        path: 'sitemap',
        element: <SitemapPage />,
      },
      {
        path: 'accessibility',
        element: <AccessibilityPage />,
      },
      {
        path: 'new-release',
        element: <NewReleasePage />,
      },
      {
        path: 'business-plates',
        element: <BusinessPlatesPage />,
      },
      {
        path: 'create',
        children: [
          {
            index: true,
            element: <Navigate to="/create/check-combination" replace />,
          },
          {
            path: 'check-combination',
            element: <CreateComboPage />,
          },
          {
            path: 'select-a-style',
            element: <CreateStylesPage />,
          },
          {
            path: 'personal-details',
            element: <CreateIdentificationPage />,
          },
          {
            path: 'checkout',
            element: <CreatePaymentPage />,
          },
          {
            path: 'success',
            element: <CreateSuccessPage />,
          },
        ],
      },
      {
        path: 'gift-vouchers',
        children: [
          {
            index: true,
            element: <GiftCardLandingPage />,
          },
          {
            path: 'personalise-voucher',
            element: <GiftCardPersonalisePage />,
          },
          {
            path: 'confirm-delivery',
            element: <GiftCardDeliveryPage />,
          },
          {
            path: 'payment',
            element: <GiftCardPaymentPage />,
          },
          {
            path: 'order-confirmation',
            element: <GiftCardSuccessPage />,
          },
          {
            path: 'balance',
            element: ENABLE_GIFT_CARDS ? <GiftCardBalancePage /> : <Navigate to="/" replace />,
          },
        ],
      },
      {
        path: 'restyle',
        children: [
          {
            index: true,
            element: <RestyleLandingPage />,
          },
          {
            path: 'check-combination',
            element: <RestyleComboPage />,
          },
          {
            path: 'select-a-style',
            element: <RestyleStylesPage />,
          },
          {
            path: 'confirm-ownership',
            element: <RestyleIdentificationPage />,
          },
          {
            path: 'checkout',
            element: <RestylePaymentPage />,
          },
          {
            path: 'success',
            element: <RestyleSuccessPage />,
          },
        ],
      },
    ],
  },
]);

export default router;
